import OrganizationsScreenContextProvider from '../../context/organizations/OrganizationsScreenContextProvider';
import MainPage from './components/MainPage';

function Organizations() {
  return (
    <OrganizationsScreenContextProvider>
      <MainPage />
    </OrganizationsScreenContextProvider>
  );
}

export default Organizations;
